import { ref } from 'vue';

/**
 * Open state of the mobile navigation drawer.
 *
 * Module-level rather than per-component because the trigger and the drawer
 * live in different subtrees: the drawer belongs to `MainLayout`, while the
 * hamburger that opens it sits in each page's own navbar. On desktop there is
 * no drawer at all — the rail expands on hover instead — so this only ever
 * matters below the `lg` breakpoint.
 */
const open = ref(false);

export const useAppNav = () => {
  return {
    open,
    openNav: () => {
      open.value = true;
    },
    closeNav: () => {
      open.value = false;
    },
  };
};
